'use strict';

const DashboardServiceImpl = require('services/DashboardServiceImpl'),
    ContentUtils = require('utils/ContentUtils'),
    DashboardServiceCache = require('services/DashboardServiceCache'),
    _ = require('lodash');

const BeerStyleStore = {

    getBeerStyles() {
        return _.sortBy(DashboardServiceCache.getBeerStyles(), 'name');
    },

    /**
     * Fetch the all of style beers.
     * @param {Function} success
     * @param {Function} failure
     */
    fetchStyleBeers(success, failure) {
        DashboardServiceImpl.getStyleBeers(function () {
            success([].slice.call(ContentUtils.parse(this.responseText)));
        }, failure);
    },

    /**
     * Change already existing style beer in the application.
     * @param {Object} styleBeer
     * @param {Function} success
     * @param {Function} failure
     */
    changeStyleBeer(styleBeer, success, failure) {
        DashboardServiceImpl.changeStyleBeer(styleBeer, function () {
            if (success) {
                success(this);
            }
        }, failure);
    },

    /**
     * Add new estyle beer in the application.
     * @param {Object} styleBeer
     * @param {Function} success
     * @param {Function} failure
     */
    addNewStyleBeer(styleBeer, success, failure) {
        DashboardServiceImpl.addStyleBeer(styleBeer, function () {
            if (success) {
                success(this);
            }
        }, failure);
    },

    /**
     * Add new estyle beer in the application.
     * @param {Object} styleBeer
     * @param {Function} success
     * @param {Function} failure
     */
    deleteStyleBeer(styleBeer, success, failure) {
        DashboardServiceImpl.deleteStyleBeer(styleBeer, function () {
            if (success) {
                success(this);
            }
        }, failure);
    },

    /**
     * Add beer style configuration to current applicant.
     * @param styleBeerConfiguration
     * @param {Function} success
     * @param {Function} failure
     */
    addBeerStyleConfiguration(configurationTank, success, failure) {
        DashboardServiceImpl.addBeerStyleConfiguration(configurationTank, function () {
            if (success) {
                success(this);
            }
        }, failure);
    },

    /**
     * Change beer style configuration to current applicant.
     * @param styleBeerConfiguration
     * @param {Function} success
     * @param {Function} failure
     */
    changeBeerStyleConfiguration(configurationTank, success, failure) {
        DashboardServiceImpl.changeBeerStyleConfiguration(configurationTank, function () {
            if (success) {
                success(this);
            }
        }, failure);
    },

    fetchStyleBeersConfiguration(beerStyleId, success, failure) {
        DashboardServiceImpl.getBeerStyleConfiguration(beerStyleId, function () {
            var configurations = [].slice.call(ContentUtils.parse(this.responseText));
            if (success) {
                success(configurations);
            }
        }, failure);
    },

    deleteStyleBeersConfiguration(id, success, failure) {
        DashboardServiceImpl.deleteBeerStyleConfiguration(id, function () {
            if (success) {
                success();
            }
        }, failure);
    }
};

module.exports = BeerStyleStore;



/** WEBPACK FOOTER **
 ** ./src/stores/BeerStyleStore.js
 **/